/**
 * h3live（换装跳舞直播间）在宿主里的地址规则。h3live 自己的 origin 不在前端配置：
 * 由服务端 /api/sk/h3live/rooms 的 embed_origin 给出（stores/h3live-rooms.js 拿一次全页共用），
 * postMessage 的 targetOrigin 和来源校验都只认那个值，绝不用 '*'。
 */

/** 宿主里通往某个直播间的页面地址；LivePage 用 liveRoomFromPath 按同一条规则解回来。 */
export function liveRoomHref(key) {
  return `/live/${encodeURIComponent(key)}`
}

/** @param {string} pathname  '/live/<key>' → key；'/live' 或其它形状 → ''（嵌 h3live 首页） */
export function liveRoomFromPath(pathname) {
  const match = /^\/live\/([^/]+)$/.exec(pathname)
  return match === null ? '' : decodeURIComponent(match[1])
}

/**
 * iframe 地址：有房间就是 /c/<key>，否则 h3live 首页。embed=1 让 h3live 收起自己的导航，
 * theme 让它跟宿主主题走而不是读自己的 localStorage，lang 让它用宿主当前的界面语言。
 * 两边的语言码是同一套（en/zh/ja/ko/es/pt），不用换算；宿主切语言时这个地址跟着变，iframe 按新语言重新加载。
 * @param {{ origin: string, room: string, theme: 'light'|'dark', locale: string }} args
 */
export function h3liveEmbedUrl({ origin, room, theme, locale }) {
  const path = room === '' ? '/' : `/c/${encodeURIComponent(room)}`
  const query = new URLSearchParams({ embed: '1', theme, lang: locale })
  return `${origin}${path}?${query}`
}
